import {
  Component,
  OnInit,
  CUSTOM_ELEMENTS_SCHEMA,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { WorkPackageInterface } from '@/app/components/projects/project-stages/plan-sections/workpackages/workpackages.component';
export interface Category {
  id?: number;
  parent_id?: number | null;
  name?: string;
  suffix?: string;
  is_custom?: number;
  is_ai_generated?: number;
  created_by?: number;
  updated_by?: number;
  created_at?: string;
  updated_at?: string;
  deleted_by?: number | null;
  deleted_at?: string | null;
  children?: any;
}
@Component({
  selector: 'measurement-standards',
  standalone: true,
  imports: [MatSelectModule, CommonModule],
  templateUrl: './measurement-standards.component.html',
  styleUrl: './measurement-standards.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MeasurementStandardsComponent implements OnInit {
  // @Input() selectedWorkPackage: any;
  @Output() valueSelected = new EventEmitter<WorkPackageInterface>(); // Emit the selected value
  @Output() valueSubSelected = new EventEmitter<WorkPackageInterface>(); // Emit the selected value

  categories: WorkPackageInterface[] = [];
  @Input() selectedCategory: WorkPackageInterface | undefined;
  subCategories: WorkPackageInterface[] | undefined = [];
  custom: WorkPackageInterface | undefined;

  selectedSubCategory: WorkPackageInterface | undefined;
  allWorkPackages: any;
  constructor(private projectsService: ProjectsService) {}

  ngOnInit() {
    this.getAllWPSI();
    // this.selectedCategory = this.selectedWorkPackage;
  }

  getAllWPSI(): void {
    this.projectsService.getAllWPSI().subscribe({
      next: (data) => {
        this.allWorkPackages = data.data;
        console.log('Response allWorkPackages: ', this.allWorkPackages);

        this.categories = this.allWorkPackages.filter(
          (wp: WorkPackageInterface) => wp.parent_id === null
        );

        this.custom = this.allWorkPackages.find(
          (wp: WorkPackageInterface) => wp.name === 'CUSTOM'
        );
        console.log('this.custom', this.custom);
        this.subCategories = this.custom?.children;
        console.log('this.subCategories', this.subCategories);
      },
      error: (error) => {
        console.error('Error fetching WPSI:', error);
      },
    });
  }
  compareCategories(
    category1: Category | null,
    category2: Category | null
  ): boolean {
    return category1 && category2
      ? category1.id === category2.id
      : category1 === category2;
  }

  onCategoryChange() {
    // If selectedCategory is not 'Custom', reset selectedSubCategory
    if (this.selectedCategory?.name !== 'Custom') {
      this.selectedSubCategory = undefined;
    } else {
      console.log('Filtering subcategories');
      this.selectedSubCategory = this.subCategories
        ? this.subCategories[0]
        : undefined;
    }
    this.valueSelected.emit(this.selectedCategory);
  }

  onSubCategoryChange() {
    this.valueSubSelected.emit(this.selectedSubCategory);
  }
}
